document.addEventListener("DOMContentLoaded", function () {
   const contentContainer = document.querySelector(
      ".page-content-dropdowns__content"
    );
    const children = Array.from(contentContainer.children);
  // Function to handle the dropdown behavior based on screen size
  function handleDropdownBehavior() {
    // Determine if we're on mobile based on a breakpoint (768px)
    const isMobile = window.innerWidth <= 768;

    // Get the content container and grab its children
   
    const sections = [];
    let currentSection = null;

    // Split content by <h1>; each section starts with an <h1> and includes following elements until the next <h1>
    children.forEach((child) => {
      if (child.tagName === "H1") {
        currentSection = document.createElement("div");
        currentSection.classList.add("section-content");
        currentSection.appendChild(child);
        sections.push(currentSection);
      } else {
        if (currentSection) {
          currentSection.appendChild(child);
        }
      }
    });

    // Get the dropdown container (do not change class names)
    const dropdownContainer = document.querySelector(
      ".page-content-dropdowns__item"
    );
   
    if (isMobile) {
      // On mobile, show the content inside each dropdown item (accordion)
      contentContainer.style.display = "none";
      dropdownContainer.innerHTML = "";

      sections.forEach((section, index) => {
        // Create a dropdown item (accordion) using the existing class name.
        const dropdownItem = document.createElement("div");
        dropdownItem.classList.add("page-content-dropdowns__item-title");

        // Create an inner header container to hold title and svg
        const headerContainer = document.createElement("div");
        headerContainer.classList.add("dropdown-header");

        const header = section.querySelector("h1");
        const titleElement = document.createElement("h3");
        titleElement.textContent = header
          ? header.textContent.trim()
          : `Section ${index + 1}`;
        headerContainer.appendChild(titleElement);

        const svgWrapper = document.createElement("div");
        svgWrapper.innerHTML = `
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#8E8D8D"></rect>
              <path d="M14 11L19 16L14 21" stroke="#8E8D8D"></path>
            </svg>`;
        headerContainer.appendChild(svgWrapper);

        // Append the header container to the dropdown item
        dropdownItem.appendChild(headerContainer);

        // Create a container for the content to be toggled within the dropdown item.
        const mobileContent = document.createElement("div");
        mobileContent.classList.add("mobile-dropdown-content");
        mobileContent.appendChild(section);
        dropdownItem.appendChild(mobileContent);

        // Set the initial height to 0 to hide all sections by default.
        mobileContent.style.height = "0";

        // Toggle behavior on click: animate height from 0 to scrollHeight and vice versa.
        dropdownItem.addEventListener("click", function (e) {
          e.stopPropagation();
          const isActive = dropdownItem.classList.contains("active");
          if (isActive) {
            dropdownItem.classList.remove("active");
            mobileContent.style.height = "0";
          } else {
            // Optionally collapse any other open items
            document
              .querySelectorAll(".page-content-dropdowns__item-title.active")
              .forEach((item) => {
                if (item !== dropdownItem) {
                  item.classList.remove("active");
                  const otherContent = item.querySelector(
                    ".mobile-dropdown-content"
                  );
                  if (otherContent) {
                    otherContent.style.height = "0";
                  }
                }
              });
            dropdownItem.classList.add("active");
            mobileContent.style.height = mobileContent.scrollHeight + "px";
          }
        });

        dropdownContainer.appendChild(dropdownItem);
      });
    } else {
      // Desktop behavior
      
      dropdownContainer.innerHTML = "";
      contentContainer.innerHTML = "";
      contentContainer.style.display = "block";
      sections.forEach((section, index) => {
        if (index === 0) {
          section.classList.add("active");
        }
        contentContainer.appendChild(section);

        // Create a dropdown item for desktop using the provided class names.
        const dropdownItem = document.createElement("div");
        dropdownItem.classList.add("page-content-dropdowns__item-title");
        if (index === 0) {
          dropdownItem.classList.add("active");
        }

        // Create an inner header container for title and svg.
        const headerContainer = document.createElement("div");
        headerContainer.classList.add("dropdown-header");

        const header = section.querySelector("h1");
        const titleElement = document.createElement("h3");
        titleElement.textContent = header
          ? header.textContent.trim()
          : `Section ${index + 1}`;
        headerContainer.appendChild(titleElement);

        const svgWrapper = document.createElement("div");
        svgWrapper.innerHTML = `
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#8E8D8D"></rect>
              <path d="M14 11L19 16L14 21" stroke="#8E8D8D"></path>
            </svg>`;
        headerContainer.appendChild(svgWrapper);

        dropdownItem.appendChild(headerContainer);

        // When the dropdown item is clicked, display only its corresponding section.
        dropdownItem.addEventListener("click", function () {
          sections.forEach((sec) => sec.classList.remove("active"));
          document
            .querySelectorAll(".page-content-dropdowns__item-title")
            .forEach((item) => item.classList.remove("active"));
          section.classList.add("active");
          dropdownItem.classList.add("active");
        });

        dropdownContainer.appendChild(dropdownItem);
        
      });
      
    }
  }

  // Initial call to handle dropdown behavior
  handleDropdownBehavior();

  // Add resize listener to handle changes in screen size
  window.addEventListener("resize", handleDropdownBehavior);
});
